export const HOTEL_CREDIT_MODAL_COOKIE = 'hotel_credit_overlay';
export const MAX_DISMISS_COUNT = 3;
export const EXPIRY_DAYS = 365;
export const BUFFER_DAYS = 7;
